import React from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import LoopVideo from './assets/hosting.webm'

class HeroVideo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }
    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: #111;
        `

        const VideoContainer = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            overflow: hidden;
            position: relative;
            video {
                position: absolute;
                @media (max-width:767px) {
                height: 750px;
                }
            }            
        `
        const Heading2 = styled.h2`
            font-size: 80px;
            font-family: Teko;
            line-height: 80px;
            color: #fff;
            font-weight: 400;
            text-transform: uppercase;
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 40px;
            }
            @media (max-width:767px) {
                margin-left: 10px;
                font-size: 22px;
                line-height: 32px;
            }
        `

        const Heading1 = styled.h1`
            font-size: 80px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            margin-top: 40px;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 25px;
                line-height: 35px;
                margin-top: 10px;
            }
            @media (min-width:768px) and (max-width:1400px) {
                font-size: 40px;
                margin-top: 50px;
            }
        `

        const Content = styled.div`
            position: relative;
            z-index: 10;
            @media (min-width:768px) and (max-width:1500px) {                
                margin-top: 100px;
            }
            @media (max-width:767px) {                
                margin-top: 100px;                
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 0 0;
        `
        const Span = styled.span`
            color: #ffffff;            
        `
        const Span1 = styled.span`
            color: #ffffff;
            font-size: 30px;            
            line-height: 40px;            
            font-weight: bold;
            text-align: center;
            font-family: roboto,sans-serif;            
        `

        const ServiceListElement = styled.li`
            list-style: none;
            color: #ffffff;
            font-weight: 300;
            font-size: 20px;
            margin: 5px 0px;
            &::before {
                display: inline-block;
                content: '';
                border-radius: 2.5px;
                height: 5px;
                width: 5px;
                margin-right: 10px;
                background-color:#ffffff;
                position: relative;
                bottom: 2.5px;
            }
                @media (max-width: 767px) {
                    font-size: 16px;
                    line-height: 26px;                        
                    }
        `
        const TextaSpan = styled.a`        
            color: #78c91c;
            font-size: 30px;            
            line-height: 40px;
            transition: .5s;
            font-weight: bold;
            text-align: center;
            font-family: roboto,sans-serif;
            margin-top: 10px;
                &:hover {
                    color: #fff;
                    text-decoration: none;
                    }
                @media (max-width: 767px) {
                    font-size: 25px;
                    line-height: 35px;                        
                    } 
        `

        return (
            <Section id="home">
                <VideoContainer style={{ height: `${this.state.width > 500 ? this.state.height : 550}px` }}>
                    <video autoPlay="autoplay" loop="loop" muted style={{ height: `${this.state.width >= 1024 && this.state.width < 1200 ? "100%" : "300"}` }}>
                        <source src={LoopVideo} type="video/mp4" />
                    </video>
                    <Container>
                        <Content>
                            <Heading1>
                                VPS Bogotá y Colombia: Servidores SSD en RAID 10
                            </Heading1>
                            <Separator />
                            <Heading2>
                                Servidores Privados Virtuales NO administrados
                            </Heading2>
                            <ServiceList>
                                <ServiceListElement>
                                    Protección DDoS real <Span>•</Span> Soporte especializado 24/7
                                </ServiceListElement>
                                <ServiceListElement>
                                    Datacenters ubicados en Texas - EEUU <Span>•</Span> Tráfico saliente NO medido
                                </ServiceListElement>
                                <ServiceListElement>
                                    99,9% Uptime <Span>•</Span> Garantía de devolución de 30 días
                                </ServiceListElement>
                            </ServiceList>
                            <TextaSpan href="#vps"
                                onClick={() => {
                                    window.gtag('event', 'click_button_vps_planes', {
                                        button_name: 'Planes VPS en VPS',
                                        destination_url: '#vps'
                                    });
                                }}>Explora nuestros VPS
                            </TextaSpan> <Span1>  o </Span1> 
                            <TextaSpan href="https://api.whatsapp.com/send?phone=573102767675"
                                rel="nofollow"
                                target="_blank"
                                onClick={() => {
                                    console.log('Clic en WhatsApp VPS, enviando evento');
                                    if (window.gtag) {
                                        window.gtag('event', 'click_whatsapp_vps', {
                                            button_name: 'WhatsApp VPS Texto',
                                            destination_url: 'https://api.whatsapp.com/send?phone=573102767675'
                                        });
                                    }
                                }}>Contacta por WhatsApp
                            </TextaSpan>
                        </Content>
                    </Container>
                </VideoContainer>
            </Section>
        )
    }
}

export default HeroVideo;